<div class="product-tile">
  <a [routerLink]="['/', product.slug]">
    <img width="150" height="200" [src]="getProductImageUrl()">
    <p> {{ product.name }} </p>
  </a>
  <ngx-input-star-rating *ngIf="product.avg_rating===0" [value]="getAvgRating(product)" [disabled]="isDIsabled"></ngx-input-star-rating>
</div>
